import { useRef } from "react";
import TechnologiesListsSection from "../components/Technologies/TechnologiesListsSection";
import { useEffect } from "react";
import DescriptionWithImageSection from "../components/Common/DescriptionWithImage";
import { useI18n } from "../i18n/I18nContext";

const Technologies = () => {
  const ref = useRef();
  const { copy } = useI18n();
  const technologiesCopy = copy.technologiesPage;

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, []);

  return (
    <div>
      <DescriptionWithImageSection
        title={
          <h2>
            {technologiesCopy.titleBefore} <br />{" "}
            <span style={{ color: "#0668E1" }}>
              {technologiesCopy.titleHighlight}
            </span>
          </h2>
        }
        paragraph={
          <p>{technologiesCopy.intro}</p>
        }
        showButton={true}
        imageInfo={{
          link: "/technology_header.webp",
          description: technologiesCopy.imageAlt,
        }}
        onBtnClick={() => {
          let dims = ref.current.getBoundingClientRect();
          window.scrollTo(window.scrollX, dims.top - 50);
        }}
      />
      <TechnologiesListsSection ref={ref} />
    </div>
  );
};

export default Technologies;
